import React, { useMemo, useState } from "react";

import {
    CalculatorOutlined,
    SearchOutlined,
    RightOutlined,
    HeartOutlined,
    ExperimentOutlined,
    DashboardOutlined,
    MedicineBoxOutlined,
    FunctionOutlined,
    SafetyCertificateOutlined,
    SwapOutlined
} from "@ant-design/icons";

import {
    medicalTools,
    medicalGroups
} from "./tools";


const groupIcon = (group) => {

    switch (group) {

        case "Tim mạch":
            return <HeartOutlined />;

        case "Thận":
        case "Điện giải & chuyển hóa":
            return <ExperimentOutlined />;

        case "Hô hấp":
            return <DashboardOutlined />;

        case "Thần kinh & cấp cứu":
            return <MedicineBoxOutlined />;

        case "Chuyển đổi":
            return <SwapOutlined />;

        default:
            return <FunctionOutlined />;
    }
};


export default function TienIchCongCuYKhoa() {

    const [search, setSearch] =
        useState("");

    const [group, setGroup] =
        useState("Tất cả");


    const filtered = useMemo(() => {

        const keyword =
            search
                .trim()
                .toLocaleLowerCase("vi");

        return medicalTools.filter((tool) => {

            const matchGroup =
                group === "Tất cả" ||
                tool.group === group;

            const haystack =
                `${tool.name} ${tool.shortName} ${tool.description} ${tool.group}`
                    .toLocaleLowerCase("vi");

            const matchSearch =
                !keyword ||
                haystack.includes(keyword);

            return (
                matchGroup &&
                matchSearch
            );
        });

    }, [search, group]);


    return (

        <div className="max-w-screen-2xl mx-auto px-3 md:px-5 pt-16 md:pt-4 pb-10">


            <div className="relative overflow-hidden bg-gradient-to-r from-violet-700 via-purple-600 to-indigo-500 rounded-2xl px-5 py-6 md:p-9 text-white">

                <div className="relative z-10 max-w-3xl">

                    <div className="flex items-center">

                        <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-white bg-opacity-20 flex items-center justify-center text-2xl">

                            <CalculatorOutlined />

                        </div>


                        <div className="ml-4">

                            <p className="text-[11px] md:text-sm font-semibold opacity-90">

                                TIỆN ÍCH Y KHOA

                            </p>


                            <h1 className="text-[27px] md:text-3xl font-bold">

                                Bộ công cụ Y khoa

                            </h1>

                        </div>

                    </div>


                    <p className="text-[14px] md:text-base leading-6 mt-4 opacity-90">

                        Các công thức, chỉ số và công cụ tính toán nhanh
                        dành cho tham khảo, học tập và hỗ trợ ghi nhận chuyên môn.

                    </p>


                    <div className="bg-white rounded-2xl h-12 flex items-center px-4 mt-5">

                        <SearchOutlined className="text-gray-400" />

                        <input
                            value={search}
                            onChange={(e) =>
                                setSearch(
                                    e.target.value
                                )
                            }
                            placeholder="Tìm eGFR, MAP, GCS, FIB-4..."
                            className="flex-1 ml-3 outline-none text-gray-700 text-sm bg-transparent"
                        />

                    </div>

                </div>

            </div>


            <div className="overflow-x-auto mt-5 pb-1">

                <div className="flex gap-2 min-w-max">

                    {medicalGroups.map((item) => (

                        <button
                            key={item}
                            type="button"
                            onClick={() =>
                                setGroup(item)
                            }
                            className={`
                                rounded-full
                                px-4 py-2
                                text-[12px] md:text-sm
                                font-semibold
                                border
                                transition
                                ${
                                    group === item
                                        ? "bg-purple-600 text-white border-purple-600"
                                        : "bg-white text-gray-600 border-gray-200"
                                }
                            `}
                        >

                            {item}

                        </button>

                    ))}

                </div>

            </div>


            <div className="flex items-end justify-between mt-6">

                <div>

                    <h2 className="text-[21px] md:text-2xl font-bold text-gray-900">

                        {group === "Tất cả"
                            ? "Tất cả công cụ"
                            : group
                        }

                    </h2>

                    <p className="text-gray-500 text-[13px] mt-1">

                        {filtered.length} công cụ

                    </p>

                </div>

            </div>


            {filtered.length > 0 ? (

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4 mt-4">

                    {filtered.map((tool) => (

                        <a
                            key={tool.slug}
                            href={`/tienich/cong-cu-y-khoa/${tool.slug}`}
                            className="group bg-white border border-gray-200 rounded-2xl p-4 md:p-5 block text-black hover:border-purple-200 hover:shadow-lg transition"
                        >

                            <div className="flex items-start">

                                <div className="w-11 h-11 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-xl flex-shrink-0">

                                    {groupIcon(tool.group)}

                                </div>


                                <div className="ml-3 flex-1 min-w-0">

                                    <div className="flex items-start justify-between">

                                        <h3 className="font-bold text-[14px] md:text-base text-gray-900 leading-5">

                                            {tool.name}

                                        </h3>

                                        <RightOutlined className="text-gray-300 text-xs ml-2 mt-1 group-hover:text-purple-500" />

                                    </div>


                                    <p className="text-[10px] font-semibold text-purple-600 mt-1">

                                        {tool.group}

                                    </p>

                                </div>

                            </div>


                            <p className="text-[12px] md:text-[13px] text-gray-500 leading-5 mt-3">

                                {tool.description}

                            </p>

                        </a>

                    ))}

                </div>

            ) : (

                <div className="bg-white border rounded-2xl text-center py-12 mt-4">

                    <SearchOutlined className="text-3xl text-gray-300" />

                    <p className="font-bold text-gray-700 mt-3">

                        Không tìm thấy công cụ

                    </p>

                </div>

            )}


            <div className="bg-purple-50 border border-purple-100 rounded-2xl p-4 md:p-5 mt-8">

                <div className="flex items-start">

                    <SafetyCertificateOutlined className="text-purple-600 text-xl mt-0.5" />


                    <div className="ml-3">

                        <p className="font-bold text-gray-800">

                            Lưu ý chuyên môn

                        </p>

                        <p className="text-[13px] md:text-sm text-gray-600 leading-6 mt-1">

                            Các calculator trên website hỗ trợ tính toán và tham khảo.
                            Kết quả không được sử dụng đơn độc để chẩn đoán,
                            kê đơn, điều chỉnh điều trị hoặc quyết định cấp cứu.
                            Luôn đối chiếu bối cảnh lâm sàng, đơn vị xét nghiệm,
                            phiên bản công thức và hướng dẫn chuyên môn hiện hành.

                        </p>

                    </div>

                </div>

            </div>

        </div>
    );
}
